module.exports = __webpack_public_path__ + "static/media/arcane_curse.327881c1.png";